import React from 'react';

import { CART_UPSELL_BANNER } from 'apps/cart/appConstants';

import { shopPods } from 'apps/cart/paths';
import { TranslatedMessage } from 'common/components/Intl';
import MembershipToggle from 'containers/MembershipToggle';

export default class CommitmentCartUpsell extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className="CartUpsellBanner CartUpsellBanner--membership">
          <div className="CartUpsellBanner__content">
            <h4 className="CartUpsellBanner__heading">
              <a className="CartUpsellBanner__heading__link" href={shopPods()}>
                <TranslatedMessage
                  id={'cart.upsell_banner.subscribe_and_save'}
                />
              </a>
            </h4>
            <p className="CartUpsellBanner__copy">
              <TranslatedMessage
                id={'cart.upsell_banner.insufficient_items'}
                values={{ count: this.props.requiredSubscribableItems }}
              />
            </p>

            {this.props.orderContainsEvergreenOffer && (
              <p className="CartUpsellBanner__copy text--body--small">
                <TranslatedMessage
                  id={'cart.upsell_banner.disable_subscription_with_device'}
                  values={{ deviceName: this.props.evergreenOfferingName }}
                />
              </p>
            )}
          </div>
          <MembershipToggle eventLocation={CART_UPSELL_BANNER} />
        </div>
      </React.Fragment>
    );
  }
}
